import { render, staticRenderFns } from "./FifthMobileSection.vue?vue&type=template&id=f0571ea2&scoped=true&"
import script from "./FifthMobileSection.vue?vue&type=script&lang=js&"
export * from "./FifthMobileSection.vue?vue&type=script&lang=js&"
import style0 from "./FifthMobileSection.vue?vue&type=style&index=0&id=f0571ea2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0571ea2",
  null
  
)

export default component.exports